import {Divider} from './index.styled';

export function TestsPanelDivider() {
	return (
		<Divider />
	);
}